import endOfDay from "date-fns/endOfDay";
import isPast from "date-fns/isPast";
import Image from "next/image";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

import BlockTitle from "@components/cms/BlockTitle/BlockTitle";
import { blurDataURL } from "@config/config";
import { useMediaQuery } from "@hooks/useMediaQuery";
import { useStore } from "@hooks/useZustandProvider";
import Button from "@ui-kit/Button/Button";
import Container from "@ui-kit/Container/Container";
import Slider from "@ui-kit/Slider/Slider";
import SliderControls from "@ui-kit/Slider/SliderControls";
import SliderSlides from "@ui-kit/Slider/SliderSlides";
import { localizedDate } from "@utils/utils";

import { typeSlider } from "./datas";
import s from "./GaleryV6Block.module.scss";

const GaleryV6Block = ({ settings, data, updateField }) => {
  const { cms } = useStore();
  const { isEditMode } = cms.uiOptions;
  const { t } = useTranslation();
  const { locale } = useRouter();
  const { isMobile } = useMediaQuery();
  const { title, collections } = data;
  const { sliderV6 } = collections;
  const { items } = sliderV6;
  const { blockType } = settings.common;

  const filterOutdateEvents = (slides) => {
    return slides.filter((event) => {
      const isDayPast = isPast(endOfDay(event.date));

      return event.isShow && !isDayPast;
    });
  };

  const slides = filterOutdateEvents(items || []);

  return !!slides.length || isEditMode ? (
    <Container className={s.galeryV6}>
      <Container full={false}>
        <section>
          <BlockTitle
            settings={settings}
            field={{ title }}
            onChange={updateField}
            type={blockType}
          />
          <Slider
            collectionType={typeSlider}
            // autoScroll
            className={s.slider}
            // startPadding={isMobile}
            slidesCount={slides.length}
            render={(sliderProps) => {
              const i = sliderProps.currentSlide;
              let date = slides[i].date;
              date = localizedDate(date, "dd MMMM yyyy", locale);
              const link = slides[i]?.link;
              return (
                <>
                  {/* <div className={s.greyBlock} /> */}
                  <div className={s.info}>
                    <div className={s.date}>{date}</div>
                    <div className={s.texts}>
                      <h3 className={s.eventName}>{slides[i].title}</h3>
                      <p>{slides[i].description}</p>
                    </div>
                    {!!link && (
                      <Button
                        target="_blank"
                        to={link}
                        className={s.button}
                        text={t("check tickets")}
                      />
                    )}
                    {!isMobile && (
                      <SliderControls className={s.controls} {...sliderProps} />
                    )}
                  </div>
                  <SliderSlides
                    {...sliderProps}
                    className={s.slides}
                    wrapClassName={s.wrapSlides}
                  >
                    {slides.map((event, key) => (
                      <div key={key} className={s.slide}>
                        <Image
                          fill
                          style={{
                            objectFit: "cover",
                            objectPosition: "center",
                          }}
                          src={event.image}
                          alt={event.alt}
                          quality={100}
                          blurDataURL={blurDataURL}
                        />
                      </div>
                    ))}
                  </SliderSlides>
                  {isMobile && (
                    <SliderControls className={s.controls} {...sliderProps} />
                  )}
                </>
              );
            }}
          />
        </section>
      </Container>
    </Container>
  ) : null;
};

export default GaleryV6Block;
